<template>
  <section class="stages-experience">
    <rwl-heading h="3" align="center" class="stages-experience__title" v-html="$t('webinars.stages_experience_title')">
    </rwl-heading>

    <ul class="stages-experience__list"  v-html="$t('webinars.stages_experience_list')">
    </ul>
    <br/>
    <p class="" style="text-align: center" v-html="$t('webinars.stages_experience_caption')">
    </p>
  </section>
</template>

<script>
  import { RwlHeading } from "@rawlplug/rawlplug-design-components-library"

  export default {
    name: "StagesExperience",
    components: { RwlHeading }
  }
</script>
<style lang="scss">
  @import "stages-tabs";

  ul.stages-experience__list {
  @include make-stages-features-list($color-rwl-cyan-100)
  }

</style>
<style lang="scss" scoped>
  @import "stages-tabs";

  .stages-experience {
    padding: $stages-tabs-content-padding;
    font-size: $stages-tabs-content-font-size;
    line-height: $stages-tabs-content-line-height;

    .rwl-heading.stages-experience__title {
      margin-bottom: $spacing-7;
    }



    @media (min-width: $breakpoint-sm-min) {
      ul.stages-experience__list {
        column-count: 2;
      }
    }

    @media (min-width: $breakpoint-md-min) {
      padding: $stages-tabs-content-md-padding;
    }
  }
</style>
